import { IGoal, resourceNameGoal } from "motw_core/Entity/IGoal";
import {
    maxDatapointAgeForDaysLeft,
    resourceNameGoalDataPoint
} from "motw_core/Entity/IGoalDataPoint";
import {
    maxGoodDaysLeft, minGoodDaysLeft
} from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/GoalCardsConstants";
import { LimitWeeklyRateDecimalPlaces } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditorPanel/ShowNewDaysLeft";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { IDataProvider } from "../../../../../../../../../motw_core/Data/IDataProvider";
import { goalsService } from '../../../../../../../../../motw_core/Services/GoalsService';
import { IGoalsContainerState } from "../../../IGoalsState";
import { IAdjustedWeeklyRate } from "./IAdjustedWeeklyRate";

export async function AdjustWeeklyRatesForGoalsAsync(goalsToAdjust: IGoal[]) {
    const adjustedWeeklyRates: IAdjustedWeeklyRate[] = [];
    CalculateAdjustedWeeklyRates(goalsToAdjust, adjustedWeeklyRates);
    HandleGoalsThatCannotBeAutoAdjusted(adjustedWeeklyRates);

    for (let tuple of adjustedWeeklyRates) {
        await SetNewWeeklyRateAsync(tuple, ClientDataProvider);
    }

    Data.Load.Single.ByStateTarget<IGoalsContainerState>("Goals");
    Data.Load.Single.ByStateTarget<IGoalsContainerState>("GoalDataPoints");
}

function CalculateAdjustedWeeklyRates(
    goalsToAdjust: IGoal[],
    adjustedWeeklyRates: IAdjustedWeeklyRate[]
) {
    for (let goal of goalsToAdjust) {
        adjustedWeeklyRates.push({
            goal,
            adjustedWeeklyRate: GetAdjustedWeeklyRate(goal),
        });
    }
}

function HandleGoalsThatCannotBeAutoAdjusted(
    adjustedWeeklyRates: IAdjustedWeeklyRate[]
) {
    const goalsThatCannotBeFixedNames = adjustedWeeklyRates
        .filter((result) => result.adjustedWeeklyRate <= 0.01)
        .map((result) => result.goal.name);

    if (goalsThatCannotBeFixedNames.length > 0) {
        const errorMessage = `Unable to automatically adjust weekly rates for the goals "${goalsThatCannotBeFixedNames.join(
            `, `
        )}"`;

        console.error(errorMessage);
    }
}

async function SetNewWeeklyRateAsync(
    adjustedWeeklyRate: IAdjustedWeeklyRate,
    dataProvider: IDataProvider
) {
    await dataProvider.UpdateRecordAsync<IGoal>(
        `${resourceNameGoal}?id=eq.${adjustedWeeklyRate.goal.id}`,
        { weeklyrate: adjustedWeeklyRate.adjustedWeeklyRate }
    );

    const datapoint = goalsService.GetNewWeeklyRateChangeDatapoint(
        adjustedWeeklyRate.goal,
        adjustedWeeklyRate.adjustedWeeklyRate
    );

    await dataProvider.AddRecordAsync(resourceNameGoalDataPoint, datapoint);
}

function GetAdjustedWeeklyRate(goal: IGoal) {
    const targetDaysLeft =
        goal.daysleft < minGoodDaysLeft
            ? maxDatapointAgeForDaysLeft
            : maxGoodDaysLeft;

    const currWeeklyRate = Number.parseFloat(goal.weeklyrate.toString());
    const newWeeklyRate = (goal.daysleft / targetDaysLeft) * currWeeklyRate;
    const roundedNewWeeklyRate = LimitWeeklyRateDecimalPlaces(newWeeklyRate);
    return roundedNewWeeklyRate;
}
